import { BitfPPathBuilder } from '@bitf/core/parsers/p-parser';

export class AppPathBuilder extends BitfPPathBuilder {}
